import * as z from 'zod'
import { baseEntitySchema } from '../../core/entity.js'

export const bandSpaceSchema = baseEntitySchema.extend({
  type: z.literal('bandspace'),
  /** @todo use the aiConfigSchema for this - but it's in ai-lib and we cannot depend on it */
  aiConfig: z.record(z.string(), z.unknown()).optional(),
})

export type BandSpace = z.infer<typeof bandSpaceSchema>

export function isBandSpace(node?: unknown): node is BandSpace {
  return bandSpaceSchema.safeParse(node).success
}
